import React from 'react';
import { Typography, Stack, CircularProgress } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

import { TaskStatus } from './LaunchpadProgress.interface';

interface StatusIconProps {
    status: TaskStatus;
    index: number;
    children?: React.ReactNode;
    hasSubtasks?: boolean;
    completedSubtasks?: number;
    totalSubtasks?: number;
    isSubtask?: boolean;
}

function StatusIcon({
    status,
    index,
    children,
    hasSubtasks,
    completedSubtasks = 0,
    totalSubtasks = 0,
    isSubtask = false,
}: StatusIconProps) {
    if (status === TaskStatus.COMPLETED && !isSubtask) {
        return <CheckCircle fontSize="large" color="success" sx={{ width: 40, height: 40 }} />;
    }

    if (hasSubtasks && totalSubtasks > 0) {
        if (completedSubtasks === totalSubtasks) {
            return <CheckCircle fontSize="large" color="success" sx={{ width: 40, height: 40 }} />;
        }

        if (completedSubtasks > 0) {
            const progress = (completedSubtasks / totalSubtasks) * 100;
            return (
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={-4}
                    sx={{
                        width: 35,
                        height: 35,
                    }}>
                    <CircularProgress variant="determinate" value={progress} size={35} thickness={3} color="success" />
                    <Stack
                        justifyContent="center"
                        alignItems="center"
                        sx={{
                            width: 29,
                            height: 29,
                            borderRadius: '50%',
                            backgroundColor: 'cement.100',
                        }}>
                        <Typography variant="h4">{index + 1}</Typography>
                    </Stack>
                </Stack>
            );
        }
    }

    if (isSubtask) {
        return (
            <Typography color={status === TaskStatus.COMPLETED ? 'success.main' : 'cement.600'}>{children}</Typography>
        );
    }

    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            sx={{
                width: 35,
                height: 35,
                borderRadius: '50%',
                backgroundColor: 'cement.100',
            }}>
            {isSubtask ? children : <Typography variant="h4">{index + 1}</Typography>}
        </Stack>
    );
}

export default StatusIcon;
